<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <ng-template #rowActionTemplate let-onClick="onClick" let-row="row">
      @if (!row.value['isDeleted']) {
        <button
          [buttonType]="'regular'"
          [buttonTheme]="'light'"
          style="align-self: center"
          (click)="onClick(); $event.stopPropagation()"
        >
          <ng-icon
            size="18"
            strokeWidth="2"
            [name]="'trash'"
            color="red"
          ></ng-icon>
        </button>
      }
    </ng-template>
    <ng-template
      #selectActionTemplate
      let-onClick="onClick"
      let-disabled="disabled"
    >
      <button
        [buttonType]="'square'"
        [buttonTheme]="'danger'"
        class="action-button var(--casper-500)"
        (click)="onClick(); $event.stopPropagation()"
        [disabled]="disabled"
      >
        <ng-icon [name]="'trash'" size="18"></ng-icon>
      </button>
    </ng-template>

    <app-api-table
      #customersTable
      [endpoint]="'/customers/tables/user'"
      [name]="name"
      [hasIndexCol]="true"
      [chartColumn]="'name'"
      [canSelect]="true"
      [DeletedRowsStyle]="true"
      [onRowClick]="canManageDrafts ? handleRowClick : undefined"
      [actionCol]="canManageDrafts ? [
        {
          actionButton: rowActionTemplate,
          headerName: 'Delete',
          onClick: deleteRow,
        },
      ] : []"
      [selectOptions]="canManageDrafts ? {
        actionButton: selectActionTemplate,
        onSelect: deleteSelected,
      } : undefined"
    ></app-api-table>
  }
</app-tab-layout>

<!-- Customer Edit Modal -->
<app-customer-edit-modal
  [isOpen]="editModalOpened()"
  [customerData]="selectedCustomer()"
  (onClose)="handleEditModalClose()"
  (onSave)="handleEditSave()"
></app-customer-edit-modal>

<app-modal
  [title]="dictionaryService.get('Confirmation')"
  size="xl"
  [opened]="deleteConfirmationModal()"
  (closeTrigger)="deleteConfirmationModal.set(false)"
>
  <h6>
    @if (customersToDelete.length === 1) {
      <ng-container>
        {{ dictionaryService.get('DeleteSingleCustomerConfirmation') }}
        <strong> {{ customersToDelete[0].value['Name'] }}</strong>
      </ng-container>
    } @else {
      <ng-container>
        {{ dictionaryService.get('DeleteCustomerConfirmation') }}
      </ng-container>
    }
  </h6>

  <div class="buttons mt-2">
    <button
      buttonTheme="danger"
      buttonType="regular"
      (click)="deleteConfirmed()"
    >
      {{ dictionaryService.get('Confirm') }}
    </button>
    <button
      buttonTheme="light"
      buttonType="regular"
      (click)="deleteConfirmationModal.set(false)"
    >
      {{ dictionaryService.get('Cancel') }}
    </button>
  </div>
</app-modal>
